'use strict';

var GridAverageFaresFilterFactory = function GridAverageFaresFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FaresFilterByMarketFactory', 'FaresFilterByClassFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridAverageFaresFilter() {
    DemandFilter.call(this, 'fares-average-mode', 'fares-average');
    this.registerFilters(injectedFilters);
  }
  GridAverageFaresFilter.prototype = Object.create(DemandFilter.prototype);
  GridAverageFaresFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridAverageFaresFilter;
};
GridAverageFaresFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = GridAverageFaresFilterFactory;